/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { throwErrorTestErrorGet } from '../fn/throw-error/throw-error-test-error-get';
import { ThrowErrorTestErrorGet$Params } from '../fn/throw-error/throw-error-test-error-get';
import { throwErrorTestErrorPost } from '../fn/throw-error/throw-error-test-error-post';
import { ThrowErrorTestErrorPost$Params } from '../fn/throw-error/throw-error-test-error-post';

@Injectable({ providedIn: 'root' })
export class ThrowErrorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `throwErrorTestErrorPost()` */
  static readonly ThrowErrorTestErrorPostPath = '/v1/ThrowError/TestErrorPost';

  /**
   * <br />Anonymous access
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `throwErrorTestErrorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  throwErrorTestErrorPost$Response(params?: ThrowErrorTestErrorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return throwErrorTestErrorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * <br />Anonymous access
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `throwErrorTestErrorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  throwErrorTestErrorPost(params?: ThrowErrorTestErrorPost$Params, context?: HttpContext): Observable<void> {
    return this.throwErrorTestErrorPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `throwErrorTestErrorGet()` */
  static readonly ThrowErrorTestErrorGetPath = '/v1/ThrowError/TestErrorGet';

  /**
   * <br />Anonymous access
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `throwErrorTestErrorGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  throwErrorTestErrorGet$Response(params?: ThrowErrorTestErrorGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return throwErrorTestErrorGet(this.http, this.rootUrl, params, context);
  }

  /**
   * <br />Anonymous access
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `throwErrorTestErrorGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  throwErrorTestErrorGet(params?: ThrowErrorTestErrorGet$Params, context?: HttpContext): Observable<void> {
    return this.throwErrorTestErrorGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
